// Fiscal year starts from July (month index 6)
export const getCurrentFiscalYear = (): number => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return currentDate.getMonth() >= 6 ? currentYear + 1 : currentYear;
};
